<script>
    import { number } from 'yup';
    import TextInput from '../../TextInput.svelte';
    import { sgettext } from '../../../i18n.js';

    export let data = '';
    export let onChange = () => {};
    export let row = null;
    export let key = '';
    export let multiline = false;
    export let schema = {}
    export let id = '';
    export let conf_read_only = false;
    export let nameSuggestions = [];
    export let numberSuggestions = [];
    export let onSave = () => {};

	let timer;

    function handleColumnChange(event) {
        onChange(event, row);
        // clearTimeout(timer);
		// timer = setTimeout(() => {
        //     onChange(event, row);
		// }, 1500);
    }

    function setValue(reference, type){
        let row_key = id.slice(-1);
        let document_name = reference.document_name;
        let document_reference = reference.document_reference;
        if(type === 'name') {
            document.getElementById(id).value = document_name.replace('<strong>', '').replace('</strong>', '');
            document.getElementById('document_reference-'+row_key).value = reference.document_reference;
        }else if(type === 'number') {
            document.getElementById(id).value = document_reference.replace('<strong>', '').replace('</strong>', '');
            document.getElementById('document_name-'+row_key).value = reference.document_name;
        }
        document.getElementById('document_description-'+row_key).value = reference.document_description;
        document.getElementById('document_url-'+row_key).value = reference.document_url;
        nameSuggestions = [];
        numberSuggestions = [];
        reference = {
            "document_name": document_name.replace('<strong>', '').replace('</strong>', ''),
            "document_reference": document_reference.replace('<strong>', '').replace('</strong>', ''),
            "document_description":  reference.document_description,
            "document_url": reference.document_url,
            "id": reference.id,
            "suggestion": true
        }
        onSave(reference);
    }

</script>

<style>
    div.autocomplete {
        /*the container must be positioned relative:*/
        position: relative;
        display: inline-block;
        /* width: 300px; */
    }
    li.autocomplete-items {
        list-style: none;
        border-bottom: 1px solid #d4d4d4;
        z-index: 99;
        /*position the autocomplete items to be the same width as the container:*/
        top: 100%;
        left: 0;
        right: 0;
        padding: 10px;
        cursor: pointer;
        background-color: #ffeeba;
        color : #dd5900;
        max-height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    li.autocomplete-items:hover {
        /*when hovering an item:*/
        background-color: #ffeeba;
        color: #dd5900;
    }

    li.autocomplete-items:active {
        /*when navigating through the items using the arrow keys:*/
        background-color: DodgerBlue !important;
        color: #ffffff;
    }	
        
    #autocomplete-items-list-name {
        position: relative;
        margin: 0;
        padding: 0;
        top: 0;
        border: 1px solid #ddd;
        background-color: #ffeeba;
    }

     #autocomplete-items-list-number {
        position: relative;
        margin: 0;
        padding: 0;
        top: 0;
        border: 1px solid #ddd;
        background-color: #ffeeba;
    }		
</style>

<div class="autocomplete">
    <TextInput
            {id}
            {key}
            bind:value={data}
            on:keyup={handleColumnChange}
            bind:isValid={row.fieldValidations[key].isValid}
            bind:errors={row.fieldValidations[key].errors}
            multiline={multiline}
            object={row}
            {schema}
            readonly={!row.new_row || (row.id && conf_read_only)}
            />
</div>

{#if nameSuggestions.length > 0 && row.new_row}
    <ul id="autocomplete-items-list-name">
        <b>{sgettext('$$SELECT_EXISTING_DOCUMENT$$')}:</b>
        {#each nameSuggestions as s}
            <li class="autocomplete-items" on:click={setValue(s,'name')}>{@html (s.document_name)}</li>
        {/each}
    </ul>
{/if}

{#if numberSuggestions.length > 0 && row.new_row}
    <ul id="autocomplete-items-list-number">
        <b>{sgettext('$$SELECT_EXISTING_DOCUMENT$$')}:</b>
        {#each numberSuggestions as s}
            <li class="autocomplete-items" on:click={setValue(s, 'number')}>{@html (s.document_reference)}</li>
        {/each}
    </ul>
{/if}